import { Component } from '@angular/core';

@Component({
  selector: 'app-seller-leaderboard-tab',
  templateUrl: './seller-leaderboard-tab.component.html',
  styleUrls: ['./seller-leaderboard-tab.component.scss']
})
export class SellerLeaderboardTabComponent {}
